export default "__VITE_ASSET__1c5b5632__"